<template>
  <AutoComplete
    ref="autoComplete"
    v-model="inputValue"
    :label="label"
    :name="name"
    :options="preInsurerOptions"
    :required="required"
    :theme="theme"
    :errors="errors"
    v-bind="$attrs"
  />
</template>

<script>
import axios from 'axios'
import { format } from 'date-fns'

import AutoComplete from './AutoComplete'

export default {
  name: 'PreInsurers',

  components: {
    AutoComplete,
  },

  props: {
    errors: {
      type: Object,
      default: undefined,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'pre-insurers',
    },
    theme: {
      default: 'white',
      validator: theme => ['white', 'green', 'gray'].includes(theme),
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    preInsurerOptions: [],
    inputValue: null,
  }),
  computed: {
    firstDayOfNextMonth() {
      const todayDate = new Date()
      const nextMonthFirstDay = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth() + 1,
        1,
      )
      return format(nextMonthFirstDay, 'yyyy-MM-dd')
    },
  },
  watch: {
    inputValue: {
      handler(value) {
        if (value) {
          this.$emit('input', value)
        }
      },
      immediate: true,
    },
    value: {
      handler(value) {
        this.inputValue = value
      },
      immediate: true,
    },
  },
  mounted() {
    this.composePreInsurers()
  },
  methods: {
    composePreInsurers() {
      const preInsurerServiceUrl = `${process.env.VUE_APP_ROOT_API}/public/masterdata/v1/preinsurers`

      return Promise.all([
        axios.get(preInsurerServiceUrl, {
          params: {
            channel: 'ALL',
            contractStartDate: this.firstDayOfNextMonth,
            insurerType: 'KVG',
          },
        }),
        axios.get(preInsurerServiceUrl, {
          params: {
            channel: 'ALL',
            contractStartDate: this.firstDayOfNextMonth,
            insurerType: 'VVG',
          },
        }),
      ]).then(([KVG, VVG]) => {
        const sortedPreInsurers = this.sortPreInsurerResults([
          ...KVG.data.data,
          ...VVG.data.data,
        ])

        this.preInsurerOptions =
          this.removeDuplicatePreInsurerEntries(sortedPreInsurers)
      })
    },
    removeDuplicatePreInsurerEntries(sortedPreInsurers) {
      const map = new Map(
        sortedPreInsurers.map(preInsurer => [
          preInsurer.id,
          { ...preInsurer, value: preInsurer.name },
        ]),
      )
      return [...map.values()]
    },
    sortPreInsurerResults(results) {
      return results.sort((a, b) => (a.name >= b.name ? 1 : -1))
    },
  },
}
</script>
